import { businessIsAllowedToSeeFeature } from '@/router/validators/utils/businessIsAllowedToSeeFeature';
import { ValidatorState } from '../types';

export function offersValidator(): ValidatorState {
  let disclaimersKeys: Array<string> = [];
  const isValid = businessIsAllowedToSeeFeature('physical');

  return {
    isValid,
    disclaimersKeys
  };
}
